export default "__VITE_ASSET__Uz10dOYG__"